import { Record } from 'immutable';

export default Record({
    campaign: null,
    campaignId: null,
    comment: null,
    createdAt: null,
    flagType: null,
    id: null,
    title: null,
    type: null,
    updatedAt: null,
});
